import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { LogIn, LogOut, User } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const LoginButton = ({ variant = 'default', size = 'default', className = '', redirectPath }) => {
  const { user, loading, loginWithGoogle, logout } = useAuth();

  if (loading) {
    return (
      <Button variant="outline" size={size} className={className} disabled>
        <span className="animate-pulse">...</span>
      </Button>
    );
  }

  if (user) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2 text-sm">
          {user.avatar_url ? (
            <img 
              src={user.avatar_url} 
              alt={user.name} 
              className="w-8 h-8 rounded-full object-cover border-2 border-slate-600"
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
              <User className="w-4 h-4 text-white" />
            </div>
          )}
          <span className="hidden md:inline text-slate-300 max-w-[120px] truncate">{user.name}</span>
        </div>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={logout}
          className="text-slate-400 hover:text-white"
          data-testid="logout-button"
        >
          <LogOut className="w-4 h-4" />
        </Button>
      </div>
    );
  }

  return (
    <Button 
      variant={variant}
      size={size}
      onClick={() => loginWithGoogle(redirectPath)}
      className={className}
      data-testid="login-button"
    >
      <LogIn className="w-4 h-4 mr-2" />
      Sign In
    </Button>
  );
};

export default LoginButton;
